export default __webpack_public_path__ + "static/media/message-bg.11d32e37.png";